import { render, staticRenderFns } from "./goal-summary.vue?vue&type=template&id=57aa9ed8&scoped=true"
import script from "./goal-summary.vue?vue&type=script&lang=js"
export * from "./goal-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa9ed8",
  null
  
)

export default component.exports